import React from 'react';
import Icon from '../../../components/AppIcon';

const GalleryHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-[var(--color-primary)]/10 to-[var(--color-accent)]/10 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center animate-fade-in">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-brand-amber)] mb-6 shadow-lg">
            <Icon name="Camera" size={32} color="#FFFFFF" />
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[var(--color-foreground)] mb-6">
            Experience the <span className="text-[var(--color-primary)]">Vibe</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-[var(--color-muted-foreground)] max-w-3xl mx-auto mb-8">
            Step into our world where authentic Mexican street food meets warm, welcoming ambience. Explore our spaces, feel the energy, and discover why Taco Street is more than just a meal—it's an experience.
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 bg-[var(--color-card)] rounded-lg">
              <Icon name="MapPin" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-[var(--color-foreground)]">Multiple Locations</span>
            </div>
            
            <div className="flex items-center gap-2 px-4 py-2 bg-[var(--color-card)] rounded-lg">
              <Icon name="Users" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-[var(--color-foreground)]">Community Spaces</span>
            </div>
            
            <div className="flex items-center gap-2 px-4 py-2 bg-[var(--color-card)] rounded-lg">
              <Icon name="Sparkles" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-[var(--color-foreground)]">Vibrant Atmosphere</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryHero;